import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// Self-hosted Poppins (bundled with the app, no Google Fonts dependency)
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "./index.css";
import "./shared/i18n/config";
import { trackTrace } from "./shared/utils/telemetry";

const GTM_CONTAINERS: Record<string, string> = {
  "app.skyporter.us": "GTM-WB8Q8PGC",
  "app-stg.skyporter.us": "GTM-PVG4D24R",
  "skyporter-appsvc-web-app-dev.azurewebsites.net": "GTM-PVG4D24R",
};

function injectGtm(): void {
  const gtmId = GTM_CONTAINERS[window.location.hostname];
  if (!gtmId || window.location.protocol !== "https:") return;

  // Inject <script> into <head>
  const script = document.createElement("script");
  script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmId}');`;
  document.head.prepend(script);

  // Inject <noscript> iframe at top of <body>
  const noscript = document.createElement("noscript");
  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";
  noscript.appendChild(iframe);
  document.body.prepend(noscript);
}

function setupRouteTracking(): void {
  const pushVirtualPageView = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "virtual_page_view",
      page_path: window.location.pathname + window.location.search,
    });
  };

  // Patch history methods
  const originalPushState = history.pushState.bind(history);
  const originalReplaceState = history.replaceState.bind(history);

  history.pushState = (...args) => {
    originalPushState(...args);
    pushVirtualPageView();
    trackTrace(`route_change: ${window.location.pathname}`, 1);
  };

  history.replaceState = (...args) => {
    originalReplaceState(...args);
    pushVirtualPageView();
    trackTrace(`route_change: ${window.location.pathname}`, 1);
  };

  window.addEventListener("popstate", pushVirtualPageView);

  // Fire on initial load
  pushVirtualPageView();
}

injectGtm();
setupRouteTracking();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
